// eslint-disable-next-line no-unused-vars
import { ICreateUser } from '../../../../../TypeScript/Interfaces/ICreateUser';

export default {
  Name: '',
  Email: '',
  ConfirmEmail: '',
  Password: '',
  ConfirmPassword: '',
  ShowPassword: false,
  ShowConfirmPassword: false,
} as ICreateUser;
